var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroku(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 98.5,
    height: 28,
    role: "img",
    "aria-label": "HEROKU",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HEROKU") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98.5,
    height: 28,
    fill: "#430098"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 100
  }, /*#__PURE__*/React.createElement("image", {
    x: 9,
    y: 7,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJ3aGl0ZSIgcm9sZT0iaW1nIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHRpdGxlPkhlcm9rdTwvdGl0bGU+PHBhdGggZD0iTTIwLjYxIDBIMy4zOUMyLjE4OSAwIDEuMjMuOTYgMS4yMyAyLjE2djE5LjY4MWMwIDEuMTk4Ljk1OSAyLjE1OSAyLjE2IDIuMTU5aDE3LjIyYzEuMiAwIDIuMTU5LS45NjEgMi4xNTktMi4xNTlWMi4xNkMyMi43Ny45NiAyMS44MTEgMCAyMC42MSAwem0uOTYgMjEuODQxYzAgLjUzOS0uNDIxLjk2LS45Ni45NkgzLjM5Yy0uNTQgMC0uOTYtLjQyMS0uOTYtLjk2VjIuMTZjMC0uNTQuNDItLjk2MS45Ni0uOTYxaDE3LjIyYy41MzkgMCAuOTYuNDIxLjk2Ljk2MXYxOS42ODF6TTYuNjMgMjAuMzk5TDkuMzMgMThsLTIuNy0yLjR2NC43OTl6bTkuNzItOS43MTljLS40NzktLjQ4LTEuMzc5LTEuMDgtMi44NzktMS4wOC0xLjYyMSAwLTMuMzAxLjQyMS00LjUuODRWMy42aC0yLjR2MTAuMzhsMS42OC0uNzhzMi43Ni0xLjI2IDUuMTYtMS4yNmMxLjIgMCAxLjUuNjYgMS41IDEuMjZ2Ny4yaDIuNHYtNy4yYy4wNTktLjE3OS4wNTktMS41MDEtLjk2MS0yLjUyek0xMy4xNyA3LjVoMi40YzEuMDgtMS4yNiAxLjYyLTIuNTIxIDEuOC0zLjloLTIuMzk5Yy0uMjQxIDEuMzc5LS44NDEgMi42NC0xLjgwMSAzLjl6Ii8+PC9zdmc+"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.1)",
    x: 592.5,
    y: 175,
    textLength: 545,
    fill: "#fff",
    fontWeight: "bold"
  }, "HEROKU"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroku);
export default __webpack_public_path__ + "static/media/heroku.f1884d3b2e3519d6ab011888c0f9d967.svg";
export { ForwardRef as ReactComponent };